import React from 'react';
import ConvertKitForm from 'convertkit-react'
import intro from "../../Images/logo.png";
import intro2 from "../../Images/logo-dark.png";
import insta from "../../Images/instagram.svg";
import linked from "../../Images/linkedin.svg";
import twitter from "../../Images/twitter.svg";
import dribbble from "../../Images/dribbble.svg";
import github from "../../Images/github.png";
import medium from "../../Images/medium.png";

export default function Footer(props){
    const {theme} = props;
    const config = {
        formId: 2184646,
        template: 'clare',
        emailPlaceholder: 'Enter Email Address',
        submitText: 'Count Me In',
      }
    var dt=new Date();
    var year = dt.getFullYear();
    return(
        <div className="footer">
            <div className="footer-base">
                <div className="details">
                    <div className="connect">
                        <a href="/"><img src={theme.mode === 'light' ? intro : intro2} className="footer-logo" /></a>
                        <p className="foot-para">Developing & designing digital products</p>
                    </div>
                    <div className="links">
                        <a href="/" ><h4 className="links-head">Vikalp Kaushik</h4></a>
                        <a href="/work"><p className="links-para">Work</p></a>
                        <a href="/story"><p className="links-para">Story</p></a>
                        <a href="/blogs"><p className="links-para">Blogs</p></a>
                        <a href="https://gumroad.com/vikalp"><p className="links-para">Products</p></a>
                    </div>
                    <div className="mail">
                        <h4 className="foot-head">Connect with me</h4>
                        <div className="connect-us">
                            <a href="https://instagram.com/vikalp._.kaushik"><img src={insta} className="social-img foot-icon"/></a>
                            <a href="https://linkedin.com/in/vikalp-kaushik-99966a1ab"><img src={linked} className="social-img foot-icon"/></a>
                            <a href="https://github.com/vikalp2502"><img src={github} className="social-img foot-icon new"/></a>
                            <a href="https://twitter.com/kaushik_vikalp"><img src={twitter} className="social-img foot-icon"/></a>
                            <a href="https://dribbble.com/vikalp2502"><img src={dribbble} className="social-img foot-icon"/></a>
                            <a href="https://medium.com/@vikalpkaushik99"><img src={medium} className="social-img foot-icon new"/></a>
                        </div>
                    </div>
                    <div className="follow">
                        <h4 className="foot-head">Join the Newletter!!</h4>
                        <p className="foot-para">Receive tips and tricks , freebie products and much more.</p>
                        <ConvertKitForm {...config} />
                    </div>
                </div>
            </div>
            <div className="copyright">Copyright © 2020-{year} SHAPE4.</div>
        </div>
    )
}